export default __webpack_public_path__ + "static/media/goods.page.soy.b814d754.png";